import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";
import App from "../../../App";

export default {
    getFactoryItemRequestApprovalFillteringData,
    getAllOperationEntitiesForDropDown,
    getAllCollectionPointForDropDown,
    getAllCollectionPointForDropDown,
    getAllCustomerbyOperationEntityID,
    updateFactoryItemRequestApproval,
    
};

async function getFactoryItemRequestApprovalFillteringData(data) {
    const response = await CommonPost('/api/FactoryItemRequestApproval/FilterFactoryItemRequestApproval', null, data);
    return response.data;
}

async function updateFactoryItemRequestApproval(datamodel) {
    let approve= {
        factoryItemRequestID: datamodel.factoryItemRequestID,
        approvedQuantity: datamodel.approvedQuantity,
        reason: (datamodel.reason),
        statusID: parseInt(datamodel.statusID),
}
    var response = await CommonPost('/api/FactoryItemRequestApproval/UpdateApproval', null, approve );
    return response;
}

async function getAllCollectionPointForDropDown(id) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["operationEntityID"] === parseInt(id) && item[1]["isActive"] === true)
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }

    return collectionPointArray;
}


async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getAllCustomerbyOperationEntityID(id) {
    var customerArray = [];
    var response = await CommonGet('/api/Customer/GetCustomerbyOperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
            customerArray[item[1]["customerID"]] = item[1]["firstName"];
    }
    return customerArray;
}







